import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DataCardComponent } from './data-card.component';
import { PreviousPeriodFooterComponent } from './previous-period-footer/previous-period-footer.component';
import { SeeMoreFooterComponent } from './see-more-footer/see-more-footer.component';

@NgModule({
  entryComponents: [
    DataCardComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatIconModule,
    NgxSkeletonLoaderModule
  ],
  declarations: [
    DataCardComponent,
    SeeMoreFooterComponent,
    PreviousPeriodFooterComponent
  ],
  exports: [
    DataCardComponent,
    SeeMoreFooterComponent,
    PreviousPeriodFooterComponent
  ]
})
export class DataCardModule {}
